/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FindConnectionsResponse } from '../models/find-connections-response';
import { NodeTypeEnum } from '../models/node-type-enum';
import { ProfileKnowsTypeEnum } from '../models/profile-knows-type-enum';

@Injectable({
  providedIn: 'root',
})
export class ConnectionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loadConnections
   */
  static readonly LoadConnectionsPath = '/connections/{target}/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadConnections()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadConnections$Response(params: {
    target: NodeTypeEnum;
    id: string;

  }): Observable<StrictHttpResponse<FindConnectionsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ConnectionsService.LoadConnectionsPath, 'get');
    if (params) {

      rb.path('target', params.target, {});
      rb.path('id', params.id, {});

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FindConnectionsResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadConnections$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadConnections(params: {
    target: NodeTypeEnum;
    id: string;

  }): Observable<FindConnectionsResponse> {

    return this.loadConnections$Response(params).pipe(
      map((r: StrictHttpResponse<FindConnectionsResponse>) => r.body as FindConnectionsResponse)
    );
  }

  /**
   * Path part for operation createProfileRelation
   */
  static readonly CreateProfileRelationPath = '/connections/{knows}/{personId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProfileRelation()` instead.
   *
   * This method doesn't expect any request body.
   */
  createProfileRelation$Response(params: {
    knows: ProfileKnowsTypeEnum;

    /**
     * the person the user knows
     */
    personId: string;

  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConnectionsService.CreateProfileRelationPath, 'post');
    if (params) {

      rb.path('knows', params.knows, {});
      rb.path('personId', params.personId, {});

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProfileRelation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createProfileRelation(params: {
    knows: ProfileKnowsTypeEnum;

    /**
     * the person the user knows
     */
    personId: string;

  }): Observable<void> {

    return this.createProfileRelation$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
